module.exports = __webpack_public_path__ + "static/media/dod-3.112eb09d.gif";